import clsx from "clsx";
import React, { ComponentPropsWithoutRef } from "react";

type ButtonVariants =
  | "default"
  | "primary"
  | "dark"
  | "danger"
  | "primaryBorder"
  | "gray"
  | "white";
type ButtonSizes = "sm" | "md" | "lg";

export interface Props extends ComponentPropsWithoutRef<"button"> {
  variant?: ButtonVariants;
  size?: ButtonSizes;
}

const VARIANT_CLASS: Record<ButtonVariants, string> = {
  default: "bg-fill text-primary-base",
  primary: "bg-primary-base text-white hover:enabled:opacity-90",
  danger: "bg-danger-base text-white hover:enabled:opacity-90",
  dark: "bg-dark-base text-white hover:enabled:bg-dark-4",
  primaryBorder: "bg-white text-primary-base border border-primary-base",
  gray: "bg-slate-50 text-slate-500 border-slate-500 hover:enabled:bg-slate-200",
  white: "bg-white text-primary-base"
};

const SIZE_CLASS: Record<ButtonSizes, string> = {
  sm: "h-8 text-sm",
  md: "h-12 text-base",
  lg: "h-16 text-lg"
};

function Button({ variant = "default", size = "md", className, children, ...rest }: Props) {
  return (
    <button
      className={clsx(
        "rounded-md px-4 font-semibold leading-4", // size
        "disabled:opacity-40",
        VARIANT_CLASS[variant],
        SIZE_CLASS[size],
        className
      )}
      type="button"
      {...rest}
    >
      {children}
    </button>
  );
}

export default Button;
